import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { User } from '@classes/user';
import { UserDetail } from '@classes/user-detail';
import { MessageBox } from '@components/message-box/message-box.component';
import { Role } from '@enums/role.enum';
import { TranslateService } from '@ngx-translate/core';
import { AutocompleteObjectValidator } from '@shared/validators/autocomplete-object-validator';
import { AuthService } from 'app/core/authentication/auth.service';
import { AccountService } from 'app/core/services/account.service';
import { UiService } from 'app/core/services/ui.service';
import { UserService } from 'app/core/services/user.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {

  userForm: FormGroup;

  Role = Role;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<UserDetailComponent>,
    public userService: UserService,
    public uiService: UiService,
    private autocompleteObjectValidator: AutocompleteObjectValidator,
    public translateService: TranslateService,
    public accountService: AccountService,
    private authSrv: AuthService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: UserDetail,
  ) { }

  ngOnInit() {
    this.initFormBuilder();
  }

  private initFormBuilder() {
    const fb = this.formBuilder;
    const userform = this.userForm = fb.group({
      id: fb.control(this.data?.user?.id),
      login: fb.control(this.data?.user?.login || '', [Validators.required, Validators.maxLength(50)]),
      firstName: fb.control(this.data?.user?.firstName || '', [Validators.required, Validators.maxLength(50)]),
      lastName: fb.control(this.data?.user?.lastName || '', [Validators.required, Validators.maxLength(50)]),
      email: fb.control(this.data?.user?.email || '', [Validators.required, Validators.maxLength(50)]),
      company: fb.control(this.data?.user?.company || null, []),
      role: fb.control({
        id: this.data?.user?.role?.id || null,
        name_: this.translateService.instant('label.role-' + this.data?.user?.role?.name)
      }, [Validators.required]),
    });
  }

  onSubmit() {
    const user = new User(this.userForm.value);

    this.uiService.addRouteLoading();
    this.userService.createOrUpdateUser(user).subscribe(data => {
      this.uiService.removeRouteLoading();
      this.dialogRef.close(true);
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onChangePassword() {
    const data = this.data;
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      data,
      hasBackdrop: true
    });

    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.uiService.displayMessageToast('user.success-modify-password');
      }
    })
  }
  onResetPassword() {
    if (this.data?.user?.login) {
      this.uiService.addRouteLoading();
      this.authSrv.forgetPassword(this.data?.user?.login).subscribe((success) => {
        const messageBoxParameter = new MessageBoxParameter();
        messageBoxParameter.title = this.translateService.instant('login.reset-password-title');
        messageBoxParameter.message = this.translateService.instant('login.reset-password-content');
        messageBoxParameter.dialog = this.dialog;
        messageBoxParameter.buttons = ['ok'];
        messageBoxParameter.width = "400px";
        MessageBox.show(messageBoxParameter).subscribe(mbResult => { });
      }, (error) => {
        console.error(error);
      }, () => {
        // this.dialogRef.close(false);
        this.uiService.removeRouteLoading();
      });
    }
  }
}
